import $http from "../../init-firebase";
import firebase from "firebase/app";
import "firebase/auth";
import router from "../../router"; 

export function signInWithEmailPassword({dispatch, state}) {
    const user= {
        email: 'test32@test.com',
        password: '12345678'
    }
    // [START auth_signin_password]
    firebase.auth().signInWithEmailAndPassword(user.email, user.password)
        .then((userCredential) => {
            state.userid = userCredential.user.id;
            dispatch('getTokenFirebase')            
        })
        .catch((error) => {
            var errorCode = error.code;
            var errorMessage = error.message;
    });
// [END auth_signin_password]
}

export async function getTokenFirebase({state}){
    firebase.auth().currentUser.getIdToken(true)
        .then(function(idToken) {
            localStorage.setItem('firetoken', idToken)
      }).catch(function(error) {
        // Handle error
      });
}

export async function loadMagazine1({ state, commit, dispatch }) {
    const idtoken = localStorage.getItem('firetoken')
    await $http.get(`issue1Wommen.json?auth=${idtoken}`)
        .then(response => {
            if (state.pages1.length == 0) {
                commit("setMagazine1View", response.data)
            }
            dispatch("loadMediaMagazine")
        })
}

export async function loadMagazine2({ state, commit, dispatch }) {
    const idtoken = localStorage.getItem('firetoken')
    await $http.get(`issue2Enviroment.json?auth=${idtoken}`).then(response => {
        if (state.pages2.length == 0) {
            commit("setMagazine2View", response.data)
        }
        dispatch("loadMediaMagazine")
    })
}

export async function loadMagazine3({ state, commit, dispatch }) {
    const idtoken = localStorage.getItem('firetoken')
    await $http.get(`issue3Youth.json?auth=${idtoken}`).then(response => {
        if (state.pages3.length == 0) {
            commit("setMagazine3View", response.data)
        }
        dispatch("loadMediaMagazine")
    })
}

export async function loadMagazine4({ state, commit, dispatch }) {
    const idtoken = localStorage.getItem('firetoken')
    await $http.get(`issue4Lgbtq.json?auth=${idtoken}`).then(response => {
        if (state.pages4.length == 0) {
            commit("setMagazine4View", response.data)
        }
        dispatch("loadMediaMagazine")
    })
}

export async function loadMagazine5({ state, commit, dispatch }) {
    const idtoken = localStorage.getItem('firetoken')
    await $http.get(`issue5Human.json?auth=${idtoken}`).then(response => {
        if (state.pages5.length == 0) {
            commit("setMagazine5View", response.data)
        }
        dispatch("loadMediaMagazine")
    })
}

export async function loadMagazine6({ state, commit, dispatch }) {   
    const idtoken = localStorage.getItem('firetoken')
    await $http.get(`issue6Bipoc.json?auth=${idtoken}`)
    .then(response => {
        if (state.pages6.length == 0) {
            commit("setMagazine6View", response.data)
        }
        dispatch("loadMediaMagazine")
    }).catch( error => {          
    })
}
export async function loadMagazine7({ state, commit, dispatch }) {   
    const idtoken = localStorage.getItem('firetoken')
    if (state.pages7.length == 0) {
        await $http.get(`issue7sustainability.json?auth=${idtoken}`)
        .then(response => {
            commit("setMagazine7View", response.data)            
            dispatch("loadMediaMagazine")
        }).catch( error => {})
    }
}
export async function loadMagazine8({ state, commit, dispatch }) {   
    const idtoken = localStorage.getItem('firetoken')  
    await $http.get(`issue8UnitedNation.json?auth=${idtoken}`)
    .then(response => {
        if (state.pages8.length == 0) {
            commit("setMagazine8View", response.data)
        }
        dispatch("loadMediaMagazine") 
    }).catch( error => {})
    
}
export async function loadMagazine9({ state, commit, dispatch }) {   
    const idtoken = localStorage.getItem('firetoken')  
    await $http.get(`issue9Gender.json?auth=${idtoken}`)
    .then(response => {
        if (state.pages9.length == 0) {
            commit("setMagazine9View", response.data)
        }
        dispatch("loadMediaMagazine") 
    }).catch( error => {})
    
}
export async function loadMagazine10({ state, commit, dispatch }) {   
    const idtoken = localStorage.getItem('firetoken')  
    await $http.get(`issue10Music.json?auth=${idtoken}`)
    .then(response => {
        if (state.pages10.length == 0) {
            commit("setMagazine10View", response.data)
        }
        dispatch("loadMediaMagazine") 
    }).catch( error => {})
    
}

export async function loadMagazine11({ state, commit, dispatch }) {   
    const idtoken = localStorage.getItem('firetoken')  
    await $http.get(`issue11Expression.json?auth=${idtoken}`)
    .then(response => {
        if (state.pages11.length == 0) {
            commit("setMagazine11View", response.data)
        }
        dispatch("loadMediaMagazine") 
    }).catch( error => {})
    
}
export async function loadMagazine12({ state, commit, dispatch }) {   
    const idtoken = localStorage.getItem('firetoken')  
    await $http.get(`issue12NewOrder.json?auth=${idtoken}`)
    .then(response => {
        if (state.pages12.length == 0) {
            commit("setMagazine12View", response.data)
        }
        dispatch("loadMediaMagazine") 
    }).catch( error => {})
    
}

export async function loadMediaMagazine({ state, commit }) {
    const idtoken = localStorage.getItem('firetoken')
    await $http.get(`mediaImg.json?auth=${idtoken}`).then(response => {
        if (state.media.length == 0) {
            commit("setMedia", response.data)
        }
    })
}


